import { STORAGE_KEYS } from "../config";

export class TokenManager {
  static setToken(token: string): void {
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
  }

  static getToken(): string | null {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  }

  static clearToken(): void {
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
  }

  static hasToken(): boolean {
    return !!this.getToken();
  }

  static getCleanToken(): string | null {
    const token = this.getToken();

    if (!token) return null;

    return token.replace("Bearer ", "");
  }

  static getBearerToken(): string | null {
    const token = this.getToken();

    if (!token) return null;

    return token.startsWith("Bearer ") ? token : `Bearer ${token}`;
  }
}
